<template lang="html">
  <div>
    <p4a-header
      :product="'ds'"
      :customer="clientName"
      :loggedIn="true"
      :background="background"
      :hoverColor="hoverColor"
      :loginNavBarIcon="loginNavBarIcon"
      :loginNavBarText="loginNavBarText"
      :fontColor="hoverFontColor"
      v-show="loaded">
    </p4a-header>
  </div>
</template>

<script>
import * as settingsApi from 'api/settingsApi'

export default {
  name: 'topbar',
  data () {
    return {
      loginSettings: null,
      authenticated: false,
      languages: [
        { language: 'nl', title: 'NL' },
        { language: 'de', title: 'DE' },
        { language: 'en', title: 'EN' },
        { language: 'fr', title: 'FR' }
      ],
      background: undefined,
      hoverColor: undefined,
      backgroundColor: undefined,
      hoverFontColor: undefined,
      loginNavBarIcon: undefined,
      loginNavBarText: undefined,
      loaded: false
    }
  },
  methods: {
    logout () {
      this.authenticated = false
      localStorage.setItem('authenticated', false)
    },
    changeLocale (locale) {
      localStorage.setItem('locale', locale)
      location.reload()
    }
  },
  computed: {
    clientName: function () {
      if (this.loginSettings != null && this.loginSettings.Clientname != null) {
        return this.loginSettings.Clientname
      } else {
        return ''
      }
    }
  },
  created () {
    let self = this
    const customLoginNavBarIcon = 'LoginNavBarIcon'
    const customLoginNavBarText = 'LoginNavBarText'
    const mainTitleTableHexColor = 'MainTitleTableHexColor'
    const mainTitleTableFontHexColor = 'MainTitleTableFontHexColor'
    const param = `?values=${customLoginNavBarIcon}&values=${customLoginNavBarText}&values=${mainTitleTableHexColor}&values=${mainTitleTableFontHexColor}`
    self.authenticated = localStorage.getItem('authenticated') === 'true'
    settingsApi.getLoginSettings().then(result => {
      if (result) {
        self.loginSettings = result
      }
    })
    settingsApi.getCustomerDataSettingsList(param).then(result => {
      result.forEach(element => {
        if (element.isCustom) {
          switch (element.Name) {
            case customLoginNavBarIcon:
              this.loginNavBarIcon = '/api/server/customerdata/' + element.Value
              break
            case customLoginNavBarText:
              this.loginNavBarText = element.Value
              break
            case mainTitleTableHexColor:
              this.background = element.Value
              this.hoverColor = element.Value
              break
            case mainTitleTableFontHexColor:
              this.backgroundColor = element.Value
              this.hoverFontColor = element.Value
              break
          }
        }
      })
      this.loaded = true
    }).catch(exception => {
      this.loaded = true
    })
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/header/header.vue